import { HttpClient } from '@angular/common/http';
import {
    Component, Inject,
    OnInit,
    ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-restore-password',
  templateUrl: './restorePassword.component.html',
  styleUrls: ['./restorePassword.component.scss'],
})
export class RestorePasswordComponent implements OnInit {
  private _httpClient: HttpClient;
  private _catchaValidationError: string;

  public showResetPasswordButton = false;
  public login: string;
  public email: string;
  public display = 1;
  public errorValue: string;
  public isSuccessPasswordRestore: boolean;
    public isPasswordRestoreWithError: boolean;
    public captchaCode: string;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private _translateService: TranslateService
  ) {
    this._httpClient = httpClient;
  }

  ngOnInit(): void {
    this._initTranslations();
  }

  private _initTranslations() {
    this._translateService
      .get(['Common.CaptchaValidationError'])
      .subscribe((result) => {
        this._catchaValidationError = result['Common.CaptchaValidationError'];
      });
  }

  restorePasswordByEmail(): void {
      const body = {
          login: this.login,
          email: this.email,
          captchaCode: this.captchaCode,
      };
    this._httpClient
      .post('./api/v1/Account/restore-password-by-email', body)
      .subscribe(
          (res: any) => {
              if (res.error == "CaptchaError") {
                  this.errorValue = this._catchaValidationError;
              } else {
                  if (res.isSuccess) {
                      this.display = 3;
                      this.isSuccessPasswordRestore = true;
                      this.isPasswordRestoreWithError = false;
                  } else {
                      this.display = 4;
                      console.error(res.errorText);
                      this.isSuccessPasswordRestore = false;
                      this.isPasswordRestoreWithError = true;
                  }
              }
        },
        (errorResponse) => {
          this.display = 4;
          console.error(errorResponse);
          this.isSuccessPasswordRestore = false;
          this.isPasswordRestoreWithError = true;
        }
      );
  }

    checkCaptcha(): void {
        this.display = 2;
  }
}
